import { render, staticRenderFns } from "./QuadroPrincipal.vue?vue&type=template&id=7e7bb0d8&scoped=true&"
import script from "./QuadroPrincipal.vue?vue&type=script&lang=js&"
export * from "./QuadroPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./QuadroPrincipal.vue?vue&type=style&index=0&id=7e7bb0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7bb0d8",
  null
  
)

export default component.exports